<template>
  <atoms-card
    class="mx-auto"
    :class="{
      'lg:max-w-2.5xl': theme !== 'v2',
      'border lg:border-gray-400 bg-blue-5 -mx-4 lg:mx-auto rounded-none lg:rounded-2.5xl': theme === 'v2'
    }"
    :shadow="theme === 'v2' ? 'none' : 'bordered'"
    rounded="md"
    size="none"
  >
    <div
      :class="{
        'py-5 px-4 lg:py-6': theme === 'default',
        'px-6 pt-6 pb-8 ': theme === 'v2'
      }"
    >
      <p
        class="font-bold mb-2 lg:mb-4"
        :class="{
          'text-xl': theme === 'default',
          'text-xl lg:text-2xl': theme === 'v2'
        }"
      >
        {{ title }}
      </p>

      <!-- eslint-disable vue/no-v-html -->
      <div
        :class="{
          'text-small lg:text-regular': theme === 'v2'
        }"
        v-html="subtitle"
      >
      </div>

      <div
        class="flex flex-wrap mt-4 mb-2"
        :class="{
          '-mx-1': theme === 'default',
          '-mx-2': theme === 'v2'
        }"
      >
        <div
          v-for="(link, i) in verticalDatas[vertical]"
          :key="i"
          class="mb-2 lg:mb-4"
          :class="{
            'w-1/2 md:w-1/4 px-1': theme === 'default',
            'px-2 w-full md:w-1/2': theme === 'v2'
          }"
        >
          <atoms-button
            :id="`cta-inline-age-${i}`"
            :ticker="theme === 'v2'"
            class="w-full py-[11px] px-[18px]"
            :theme="theme === 'v2' ? 'secondary2': 'primary'"
            size="medium"
            :to="link.link"
          >
            {{ link.label }}
          </atoms-button>
        </div>
      </div>

      <div
        :class="{
          'p-4 bg-gray-300 text-center rounded-md': theme === 'default'
        }"
      >
        <p
          :class="{
            'text-sm': theme === 'default',
            'text-xs lg:text-sm text-gray-80': theme === 'v2'
          }"
        >
          {{ disclaimer }}
        </p>
      </div>
    </div>
  </atoms-card>
</template>

<script setup>
defineOptions({
  name: 'MoleculesInlineAge'
})

const props = defineProps({
  title: {
    type: String,
    default: 'Paying too much?'
  },

  subtitle: {
    type: String,
    default: '<strong>Australia:</strong> We saved our customers an average of $300* on their annual premium! <strong>Select your age below</strong> and see how much you could save!'
  },

  disclaimer: {
    type: String,
    default: '*Average savings based on 136,746 customers between 1 Jan 2018 - 23 December 2022'
  },

  vertical: {
    type: String,
    default: 'Health Insurance'
  },

  redirectUrl: {
    type: String,
    default: '/health-insurance/quote/form/step1/'
  },

  theme: {
    type: String,
    default: 'default'
  }
})

const verticalDatas = {
  'Health Insurance': [
    {
      label: '> 75 years',
      link: `${props.redirectUrl}?age=76`
    },
    {
      label: '75 - 65 years',
      link: `${props.redirectUrl}?age=70`
    },
    {
      label: '64 - 55 years',
      link: `${props.redirectUrl}?age=60`
    },
    {
      label: '< 55 years',
      link: `${props.redirectUrl}?age=35`
    }
  ]
}
</script>
